import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '../../custom-material/Services/';
import { ObjectifModel, IndicateurModel, AnswerModel, BuildingModel, UserModel, DiagnosticModel } from '../../main/Models/';

@Component({
  selector: 'mdr-objectif-form',
  templateUrl: './t_objectif-form.component.html',
  styleUrls: ['./objectif-form.component.less']
})
export class ObjectifFormComponent implements OnInit {

  objectif:ObjectifModel;

  indicator: IndicateurModel;
  answer: AnswerModel;
  building: BuildingModel;
  diagnostic: DiagnosticModel;

  constructor(public dialogRef: MatDialogRef<ObjectifFormComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private apiService:ApiService) {
  	this.indicator = data.indicator;
  	this.answer = data.answer;
  	this.building = data.building;
    this.diagnostic = data.diagnostic;
  }

  ngOnInit() {
    if(this.indicator!=undefined) {
    	this.objectif = new ObjectifModel({
    		name: this.indicator.name,
    		answer: this.answer,
    		building: this.building,
        diagnostic: this.diagnostic
    	});

      if(!this.indicator.preco) {
        this.loadPreco();
      }
    
    } else {
      this.objectif = new ObjectifModel({
        building: this.building
      });
    }

    
  }

  loadPreco()
  {
    let params = this.apiService.createParams({'indicator': this.indicator.id});
    this.apiService.getFromServer('preconization', params)
      .then(s => s.subscribe((response:any) => {
        /*response._embedded.preconization.forEach((p)=>{
          if()
        })*/
      //TODO filtrer selon le buildingType (j'ai pas encore trouvé)
        this.indicator.preco = response._embedded.preconization[0];
      }));
  }

}
